import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { OrderInfo } from '../_model/OrderInfo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayerService {
  constructor(private http: HttpClient) { }

  /*getData(r: string): Observable<OrderInfo> {
    return this.http.get<OrderInfo>(`${environment.api.getOrderInfo}?r=${r}`);
  }*/
  getData(inputJson:any): Observable<any> {
    console.log(inputJson);
    return this.http.post<any>(`${environment.api.universalCall}`, inputJson);
  }
}
